import { render, staticRenderFns } from "./RadioSecondaryButton.vue?vue&type=template&id=1d377679&scoped=true"
import script from "./RadioSecondaryButton.vue?vue&type=script&lang=ts"
export * from "./RadioSecondaryButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioSecondaryButton.vue?vue&type=style&index=0&id=1d377679&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d377679",
  null
  
)

export default component.exports